import { FC, useState } from 'react'
import { Button, Form, Schema, Stack } from 'rsuite'
import useTranslation from 'next-translate/useTranslation'

import TextInput from '../../Modals/MultiStepFormModal/Inputs/TextInput'
import { showNotification } from '../../../utils/notify'
import { ZapierType } from '../../../utils/constants'
import useZapier from '../../../services/useZapier'

import styles from '../../../styles/UserEmailForm.module.less'
import buttonStyles from '../../../styles/CustomButtons.module.less'

const { StringType } = Schema.Types

const UserEmailForm: FC = () => {
  const { t } = useTranslation('modals')
  const [email, setEmail] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const sendDataToZapier = useZapier()

  const emailModel = Schema.Model({
    workEmail: StringType()
      .isEmail(t('auth:Please enter a valid email'))
      .isRequired(t('auth:The email is required')),
  })

  const handleSubmit = async (validEmail: boolean) => {
    if (!validEmail) return

    setIsLoading(true)

    const formData = new FormData()
    const type = ZapierType.emptyStateContactRequest

    formData.append('email', email)
    formData.append('type', type)
    formData.append('url', window.location.href)

    const handleSuccess = () => {
      showNotification(
        'success',
        t('Your request has been received'),
        t('Thank you, we will contact you as soon as possible at {{email}}', {
          email,
        }),
      )
    }

    const handleError = () => {
      showNotification(
        'error',
        t('Error'),
        t('Something went wrong, contact us directly by phone or email', {
          email,
        }),
      )
    }

    await sendDataToZapier(formData, handleSuccess, handleError)
    setIsLoading(false)
  }

  return (
    <Form
      fluid
      model={emailModel}
      onSubmit={handleSubmit}
      className={styles['email-form']}
    >
      <Stack>
        <Stack.Item grow={1}>
          <TextInput
            name="workEmail"
            type="email"
            id="email"
            value={email}
            onChange={(value) => setEmail(value)}
            placeholder={t('modals:companyEmail')}
          />
        </Stack.Item>
        <Button
          appearance="ghost"
          type="submit"
          loading={isLoading}
          className={`${buttonStyles['custom-button']} ${buttonStyles['button-tertiary']} ${buttonStyles['button-caret']}`}
        >
          {t('Send')}
        </Button>
      </Stack>
    </Form>
  )
}

export default UserEmailForm
